import { PatientCalendarEntry } from './calendarSync';

export interface ImportRow
  extends Omit<PatientCalendarEntry, 'guarantors' | 'primaryCareProvider'> {
  primaryCareProviderFirstName?: string;
  primaryCareProviderLastName?: string;
  primaryCareProviderPhoneNumber?: string;
  primaryCareProviderEhrId?: string;
  primaryCareProviderApiId?: string;
  primaryCareProviderNpi?: string;
}

export const IMPORT_COLUMNS: (keyof ImportRow)[] = [
  'firstName',
  'lastName',
  'dateOfBirth',
  'sex',
  'phoneNumber',
  'cellPhoneNumber',
  'homePhoneNumber',
  'workPhoneNumber',
  'patientEhrId',
  'email',
  'phoneCommunicationConsented',
  'emailCommunicationConsented',
  'textCommunicationConsented',
  'enrolledInEhrPortal',
  'preferredLanguage',
  'lastPatientEhrLoginTimestamp',
  'primaryCareProviderFirstName',
  'primaryCareProviderLastName',
  'primaryCareProviderPhoneNumber',
  'primaryCareProviderEhrId',
  'primaryCareProviderApiId',
  'primaryCareProviderNpi',
  'advisories',
  'advisoryEventDates',
  'homeMarket',
];
